"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploadImage = exports.openImage = exports.imageUploadCTA = exports.imageLoadingSuccessful = exports.imageLoadingStart = exports.imageLoadingFailed = exports.backImageUpload = void 0;
var _react = _interopRequireDefault(require("react"));
var _uuid = require("uuid");
var _messagesActions = require("./messagesActions");
var _selectors = require("../selectors");
var _timeUtil = require("../helpers/timeUtil");
var _imageHelper = require("../helpers/imageHelper");
var _types = require("./types");
var _modalActions = require("./modalActions");
var _ImageUploadErrorModal = require("../components/molecules/ImageUploadErrorModal");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var imageUploadEndpoint = "https://chat-images.olx.com.br/image";
var imageUploadTimeout = parseFloat("30000");

// ====================================================================
// Typed actions
// ====================================================================

var imageLoadingStart = exports.imageLoadingStart = function imageLoadingStart(imageId, roomname, imageFile) {
  return {
    type: _types.IMAGE_LOADING_START,
    value: {
      imageId: imageId,
      imageFile: imageFile,
      roomname: roomname,
      timestamp: (0, _timeUtil.curTimestamp)()
    }
  };
};
var imageLoadingSuccessful = exports.imageLoadingSuccessful = function imageLoadingSuccessful(imageId, roomname) {
  return {
    type: _types.IMAGE_LOADING_SUCCESSFUL,
    value: {
      imageId: imageId,
      roomname: roomname
    }
  };
};
var imageLoadingFailed = exports.imageLoadingFailed = function imageLoadingFailed(imageId, roomname) {
  return {
    type: _types.IMAGE_LOADING_FAILED,
    value: {
      imageId: imageId,
      roomname: roomname
    }
  };
};

// ====================================================================
// Functions actions
// ====================================================================

var openImage = exports.openImage = function openImage(imageSource) {
  return function (dispatch, _, _ref) {
    var Lurker = _ref.Lurker;
    Lurker.openImageClick(imageSource);
    if (typeof window !== 'undefined' && window.open) {
      window.open(imageSource);
    }
  };
};
var uploadImage = exports.uploadImage = function uploadImage(imageFile) {
  return function (dispatch, getState, _ref2) {
    var Lurker = _ref2.Lurker;
    var roomname = (0, _selectors.getCurrentRoomname)(getState());
    var imageId = (0, _uuid.v4)();
    Lurker.imageUploadStarted(imageId);
    if (!(0, _imageHelper.isImageSizeAllowed)(imageFile)) {
      Lurker.imageUploadFailed(imageId, 'Image too large');
      dispatch((0, _modalActions.openModal)( /*#__PURE__*/(0, _jsxRuntime.jsx)(_ImageUploadErrorModal.BigImageErrorModal, {})));
      return null;
    }
    var timeoutPromise = new Promise(function (__, reject) {
      setTimeout(function () {
        return reject(new Error('Image upload timeout'));
      }, imageUploadTimeout);
    });
    var body = new FormData();
    body.append('data', imageFile);
    body.append('roomname', roomname);
    dispatch(imageLoadingStart(imageId, roomname, imageFile));
    var uploadPromise = fetch("".concat(imageUploadEndpoint), {
      method: 'POST',
      cache: 'no-cache',
      body: body
    });
    return Promise.race([timeoutPromise, uploadPromise]).then(function (response) {
      var status = response.status;
      if (status === 200) {
        return response.json();
      }
      var error = new Error("Unexpected error uploading image: ".concat(response.status));
      error.response = response;
      throw error;
    }).then(function (_ref3) {
      var url = _ref3.url;
      Lurker.imageUploadSuccessful(imageId);
      dispatch((0, _messagesActions.sendImage)(url, imageId));
    })["catch"](function (error) {
      Lurker.imageUploadFailed(imageId, error);
      dispatch(imageLoadingFailed(imageId, roomname));
      if (error.response && error.response.status === 400) {
        dispatch((0, _modalActions.openModal)( /*#__PURE__*/(0, _jsxRuntime.jsx)(_ImageUploadErrorModal.InvalidImageErrorModal, {})));
      } else {
        dispatch((0, _modalActions.openModal)( /*#__PURE__*/(0, _jsxRuntime.jsx)(_ImageUploadErrorModal.GenericErrorModal, {})));
      }
    });
  };
};
var backImageUpload = exports.backImageUpload = function backImageUpload() {
  return function (dispatch, _, _ref4) {
    var Lurker = _ref4.Lurker;
    Lurker.clickBackImageUpload();
  };
};
var imageUploadCTA = exports.imageUploadCTA = function imageUploadCTA(imageUploadType) {
  return function (dispatch, _, _ref5) {
    var Lurker = _ref5.Lurker;
    Lurker.clickImageUploadCTA(imageUploadType);
  };
};